import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@/components/ui/input-group";
import { cn } from "@/lib/utils";
import { Search, X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const SearchInput = ({
  value,
  onChange,
  placeholder,
  className,
}: SearchInputProps) => {
  const { t } = useTranslation();
  return (
    <InputGroup
      className={cn("overflow-hidden w-full border-gray-100", className)}
    >
      <InputGroupAddon
        align="inline-start"
        className="cursor-pointer select-none"
      >
        <Search />
      </InputGroupAddon>
      <InputGroupInput
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder ? placeholder : t("keys.search")}
        className="h-8 placeholder:text-sm"
      />
      {value.length > 0 && (
        <InputGroupAddon
          align="inline-end"
          className="cursor-pointer select-none"
          onClick={() => onChange("")}
        >
          <X />
        </InputGroupAddon>
      )}
    </InputGroup>
  );
};

export default SearchInput;
